var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.$userIsClient
            ? _c("img", {
                class: {
                  "col-xs-6": _vm.$userIsClient,
                  "col-xs-0": _vm.$userIsAdmin || _vm.$userIsManager,
                },
                attrs: { src: _vm.talent.profile_image_url },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-md-12 col-lg-12 response-col",
              class: {
                "col-xs-6": _vm.$userIsClient,
                "col-xs-12": _vm.$userIsAdmin || _vm.$userIsManager,
              },
            },
            [
              _c(
                "div",
                {
                  class: {
                    "col-lg-6 col-md-4 col-sm-12 col-xs-12":
                      _vm.$userIsAdmin || _vm.$userIsManager,
                    "col-lg-9 col-md-9 col-sm-12 col-xs-12":
                      _vm.$userIsClient &&
                      _vm.talent.response.expiry_date === null,
                    "col-lg-5 col-md-3 col-sm-12 col-xs-12":
                      _vm.$userIsClient &&
                      !(_vm.talent.response.expiry_date === null),
                  },
                },
                [
                  _c("a", { attrs: { href: _vm.profileUrl } }, [
                    _c("h3", { staticStyle: { cursor: "pointer" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.talent.name) +
                          "\n            "
                      ),
                      _vm.showCustomBudget
                        ? _c("div", [
                            _c("span", { staticClass: "text-primary" }, [
                              _vm._v(
                                "\n                Custom " +
                                  _vm._s(_vm.$t("budget")) +
                                  " " +
                                  _vm._s(
                                    _vm.talent.response.budget
                                      ? _vm.talent.response.budget
                                      : _vm.talent.response
                                          .budget_per_star_as_user_rate
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ])
                        : _vm.talent.response.shortlisted && !_vm.$isNflClient
                        ? _c("div", [
                            _c("span", { staticClass: "text-primary" }, [
                              _vm._v(
                                "\n                shortlisted\n              "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.talent.response.applied_date && _vm.$userIsAdmin
                        ? _c("div", { staticClass: "spacer-t-2" }, [
                            _c("p", { staticClass: "small" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$declineModuleEnabled
                                      ? _vm.$t("Applied")
                                      : "Accepted"
                                  ) +
                                  " On:\n                "
                              ),
                              _c("span", { staticClass: "text-primary" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("date")(
                                        _vm.talent.response.applied_date,
                                        _vm.$user.date_format_preference
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.talent.response.status === "applied" &&
                      _vm.talent.response.expiry_date &&
                      _vm.$userIsAdmin &&
                      !_vm.talent.response.expired
                        ? _c("div", [
                            _c(
                              "p",
                              { staticClass: "text-primary" },
                              [
                                _c("countdown-admin", {
                                  attrs: {
                                    deadline: _vm.talent.response.expiry_date,
                                    talent: _vm.talent,
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.talent.response.expired && _vm.$userIsAdmin
                        ? _c("div", [
                            _vm._v("\n              EXPIRED\n            "),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.$userIsAdmin || _vm.$userIsManager
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 spacer-y-1",
                      class: {
                        "col-lg-offset-3 col-md-offset-4": _vm.$userIsManager,
                      },
                    },
                    [
                      _c("selectize", {
                        staticClass: "form-control selectize selectize-single",
                        attrs: {
                          name: "admin_response_options",
                          disabled: _vm.userCannotUpdateTalentResponse,
                          "disable-delete": true,
                          options: _vm.talentResponseStatusOptions,
                        },
                        model: {
                          value: _vm.stateTalentResponseStatus,
                          callback: function ($$v) {
                            _vm.stateTalentResponseStatus = $$v
                          },
                          expression: "stateTalentResponseStatus",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.talent.response.status === "applied" &&
              _vm.talent.response.expiry_date &&
              _vm.$userIsClient &&
              !_vm.talent.response.expired
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 countdown-client",
                    },
                    [
                      _c("p", { staticClass: "text-primary" }, [
                        _c(
                          "span",
                          { staticStyle: { color: "#ff0000" } },
                          [
                            _c("countdown-client", {
                              attrs: {
                                deadline: _vm.talent.response.expiry_date,
                                talent: _vm.talent,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.talent.response.status === "applied" &&
              _vm.talent.response.expiry_date &&
              _vm.$userIsClient &&
              _vm.talent.response.expired
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4" },
                    [_c("h3", [_vm._v("\n          Expired\n        ")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin || _vm.$userIsClient
                ? _c(
                    "div",
                    {
                      staticClass: "col-xs-12 spacer-y-1",
                      class: {
                        "col-sm-6 col-md-4 col-lg-3": _vm.$userIsAdmin,
                        "col-sm-8 col-md-4 col-lg-3": _vm.$userIsClient,
                      },
                    },
                    [
                      _vm.talentResponseAccepted
                        ? _c(
                            "ladda-button",
                            {
                              staticClass:
                                "btn btn-success-outline btn-block my-cool-button",
                              attrs: {
                                click: _vm.handleUnselectTalentCallback,
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-check" }),
                              _vm._v(" Selected\n        "),
                            ]
                          )
                        : _vm.$userIsAdmin && _vm.talentResponseDeclined
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "btn btn-danger-outline btn-block btn-not-clickable truncate",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.talentResponseDeclineReason) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm.talentResponseDeclined
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "btn btn-danger-outline btn-block btn-not-clickable truncate",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("sentenceCase")(_vm.$starLabel)
                                  ) +
                                  " Declined\n        "
                              ),
                            ]
                          )
                        : _vm.userCanAcceptMoreTalent &&
                          _vm.talentResponseReviewing
                        ? _c(
                            "ladda-button",
                            {
                              staticClass:
                                "btn btn-info btn-block btn-accept-talent",
                              attrs: { disabled: "", click: () => {} },
                            },
                            [_vm._v("\n          Reviewing Request\n        ")]
                          )
                        : _vm.userCanAcceptMoreTalent &&
                          !_vm.talentResponseApplied &&
                          !_vm.talentResponseExpired
                        ? _c(
                            "ladda-button",
                            {
                              staticClass:
                                "btn btn-grey btn-block btn-accept-talent",
                              attrs: { disabled: "", click: () => {} },
                            },
                            [_vm._v("\n          Awaiting Response\n        ")]
                          )
                        : _vm.userCanAcceptMoreTalent &&
                          _vm.talentResponseApplied &&
                          !_vm.talentResponseExpired
                        ? _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-success btn-block",
                              attrs: {
                                disabled:
                                  !_vm.talentResponseApplied ||
                                  !_vm.canBeBooked,
                                click: _vm.handleConfirmEventDate,
                              },
                            },
                            [
                              _vm.showDateAppliedFor
                                ? _c("span", [
                                    _vm._v(
                                      "Book " +
                                        _vm._s(
                                          _vm._f("sentenceCase")(_vm.$starLabel)
                                        ) +
                                        " For"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("date")(
                                          _vm.talent.response.date_applied_for,
                                          _vm.$user.date_format_preference
                                        )
                                      )
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$userIsClient &&
                                          !_vm.$clientsCanMakeBookings
                                          ? "Select"
                                          : "Book"
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm._f("sentenceCase")(_vm.$starLabel)
                                        )
                                    ),
                                  ]),
                            ]
                          )
                        : _vm.talentResponseExpired && _vm.$userIsClient
                        ? _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-block btn-grey",
                              attrs: { click: _vm.handleContactUsCallback },
                            },
                            [_vm._v("\n          Contact Us\n        ")]
                          )
                        : _vm.talentResponseExpired && _vm.$userIsAdmin
                        ? _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-block btn-grey",
                              attrs: {
                                click:
                                  _vm.handleReactivateTalentApplicationCallback,
                              },
                            },
                            [
                              _vm._v(
                                "\n          REACTIVATE APPLICATION\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.canAddCommentForTalent && !(_vm.comment && _vm.comment.length)
            ? _c(
                "div",
                { staticClass: "col-xs-12 comment-toggle spacer-t-1" },
                [
                  !_vm.showCommentInputField
                    ? _c(
                        "a",
                        { on: { click: _vm.toggleShowCommentInputField } },
                        [
                          _c("i", { staticClass: "fa fa-chevron-down" }),
                          _vm._v(" Show Comment Box"),
                        ]
                      )
                    : _c(
                        "a",
                        { on: { click: _vm.toggleShowCommentInputField } },
                        [
                          _c("i", { staticClass: "fa fa-chevron-up" }),
                          _vm._v(" Hide Comment Box"),
                        ]
                      ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCommentInputField
            ? _c("transition", { attrs: { name: "fade" } }, [
                _vm.canAddCommentForTalent
                  ? _c(
                      "div",
                      { staticClass: "transition-text-area col-xs-12 m-t-md" },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.comment,
                                expression: "comment",
                              },
                            ],
                            ref: "comment_text_area",
                            staticClass:
                              "form-control comment-box response-text-area",
                            attrs: {
                              name: "comment",
                              rows: "2",
                              placeholder: _vm.commentPlaceholderText,
                            },
                            domProps: { value: _vm.comment },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.comment = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors
                            ? _c("span", { staticClass: "error-colour" }, [
                                _c("br"),
                                _vm._v(_vm._s(_vm.errors.first("comment"))),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.talent.response.status === "declined" &&
                          _vm.talent.response.shortlisted
                            ? _c("span", [
                                _vm._v(
                                  "Please note that the client will see your comment"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn-group btn-group-response pull-right",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-default inactive margin-r-1",
                                  on: {
                                    click: () => {
                                      this.showCommentInputField = false
                                    },
                                  },
                                },
                                [_vm._v("\n              Cancel\n            ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "ladda-button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-primary inactive",
                                  attrs: {
                                    disabled: !_vm.comment,
                                    click: _vm.handleAddCommentCallback,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Save Comment\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showComment && !_vm.showCommentInputField
        ? _c("div", { staticClass: "speech-bubble" }, [
            _c("i", [_vm._v(_vm._s(_vm.talent.response.comment))]),
            _c("br"),
            _vm._v(" "),
            _vm.showComment && !_vm.showCommentInputField
              ? _c("div", { staticClass: "commenter" }, [
                  _vm.$userIsClient
                    ? _c("span", [_vm._v("Updated ")])
                    : _c("span", [
                        _vm._v(
                          "Updated By " +
                            _vm._s(
                              _vm._f("sentenceCase")(_vm.responseUpdatedBy)
                            ) +
                            " "
                        ),
                      ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(" - " + _vm._s(_vm.responseUpdatedAt) + " "),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      (_vm.$userIsAdmin || _vm.$userIsManager) &&
      _vm.showComment &&
      !_vm.showCommentInputField
        ? _c(
            "div",
            { staticClass: "response-list-item-delete-button" },
            [
              _c(
                "ladda-button",
                {
                  key: "delete-comment",
                  staticClass: "btn btn-danger btn-sm",
                  attrs: { click: _vm.handleDeleteCommentCallback },
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" Remove Comment\n    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-info",
                  on: {
                    click: () => {
                      _vm.showCommentInputField = true
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-pencil" }),
                  _vm._v(" Edit Comment\n    "),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "2px" } }),
      _vm._v(" "),
      _c("booking-talent-response-decline-modal", {
        ref: "modal",
        attrs: { booking: _vm.booking },
        on: {
          "comment-added": (comment) => {
            this.comment = comment
            this.decline_modal_submitted = true
          },
        },
        model: {
          value: _vm.declineRequestReason,
          callback: function ($$v) {
            _vm.declineRequestReason = $$v
          },
          expression: "declineRequestReason",
        },
      }),
      _vm._v(" "),
      _vm.booking.has_date_options_only
        ? _c("booking-talent-date-applied-for-modal", {
            attrs: {
              talentId: _vm.talent.id,
              booking: _vm.booking,
              dates: _vm.booking.date_options,
            },
            model: {
              value: _vm.dateAppliedFor,
              callback: function ($$v) {
                _vm.dateAppliedFor = $$v
              },
              expression: "dateAppliedFor",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }